import React from 'react';
import { useBreakpoint, useHover } from '@landr/maestro';
import {
    ContentSuggestionPayload,
    SuggestionsType,
} from 'components/Filters/context/SearchBarContext/types';
import useDeleteUserRecentSearch from 'apollo/userRecentSearch/useDeleteUserRecentSearch';
import { useAuthentication } from 'contexts/AuthenticationProvider/AuthenticationProvider';
import useContentSuggestionItem from '../hooks/useContentSuggestionItem';
import SuggestionGeneric from './SuggestionGeneric';

export const ContentSuggestionItem = ({
    modifiers,
    suggestionType,
    isSelected,
}: {
    modifiers: ContentSuggestionPayload;
    suggestionType: SuggestionsType;
    isSelected: boolean;
}) => {
    const [hoverRef, isHovered] = useHover(false);
    const isModal = useBreakpoint('md');

    const { isAuthenticated } = useAuthentication();

    const deleteUserRecentSearch = useDeleteUserRecentSearch({
        isAuthenticated,
    });

    const {
        filterName,
        icon,
        isNavigationItem,
        isRemoveSuggestionVisible,
        filterCategories,
        handleClick,
        handleRemoveRecentSuggestion,
    } = useContentSuggestionItem({
        isHovered,
        modifiers,
        suggestionType,
        deleteUserRecentSearch,
    });

    if (!filterName) {
        return null;
    }

    return (
        <SuggestionGeneric
            hoverRef={hoverRef}
            filterName={filterName}
            filterCategories={filterCategories}
            handleClick={handleClick}
            handleRemoveRecentSuggestion={handleRemoveRecentSuggestion}
            isRemoveSuggestionVisible={isRemoveSuggestionVisible}
            icon={icon}
            isModal={isModal}
            isSelected={isSelected}
            isNavigationItem={isNavigationItem}
        />
    );
};
